import { render, staticRenderFns } from "./TACardErrorDisplay.vue?vue&type=template&id=285f7d80&scoped=true"
import script from "./TACardErrorDisplay.vue?vue&type=script&lang=js"
export * from "./TACardErrorDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285f7d80",
  null
  
)

export default component.exports